import { useLingui } from '@lingui/react/macro';
import type { FiltersStyle } from '../../../../types';
import { useAvailableFilters } from '../../../utils/use-available-filters';
import { TagsControlWrapper } from './tags-control-wrapper';

type CategoriesProps = {
  setting: string;
  type: FiltersStyle;
};

export const Categories = (props: CategoriesProps) => {
  const {
    filterItems: { categories }
  } = useAvailableFilters();
  const { t } = useLingui();

  return (
    <TagsControlWrapper
      {...props}
      label={t`Categories`}
      options={categories.map(({ id, name, icon }) => ({
        value: id,
        label: name,
        iconSrc: icon?.url
      }))}
    />
  );
};
